import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Alert, Box, Button, Paper, Stack, TextField } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { useTranslation } from 'react-i18next';
import {
  SMART_COLORS as COLORS,
  smartCardSx as cardSx,
} from '../../theme/smartStableTheme';
import SettingsPageHeader from '../../components/SettingsPageHeader';

const apiUrl = process.env.REACT_APP_API_URL;

const FarrierMaterialAdd = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const isRtl = String(i18n.language || '').startsWith('ar');
  const [material, setMaterial] = useState({
    medication_name: '',
    stock_quantity: '',
    price: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const updateField = (field, value) => setMaterial((current) => ({ ...current, [field]: value }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError('');
    try {
      await axios.post(`${apiUrl}/farrier_materials`, material);
      navigate('/farrier-materials');
    } catch (err) {
      setError(err?.response?.data?.error || t('farrierMaterials.saveError'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box className="smart-page-container" dir={isRtl ? 'rtl' : 'ltr'} sx={{ bgcolor: COLORS.page, minHeight: '100vh', maxWidth: 'var(--app-page-max)', mx: 'auto' }}>
      <SettingsPageHeader
        title={t('farrierMaterials.addTitle')}
        subtitle={t('farrierMaterials.formHint')}
        backTo="/farrier-materials"
      />

      {error && <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>{error}</Alert>}

      <Paper elevation={0} sx={{ ...cardSx, p: { xs: 2, md: 3 } }}>
        <Box component="form" onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <TextField label={t('farrierMaterials.name')} value={material.medication_name} onChange={(event) => updateField('medication_name', event.target.value)} required fullWidth />
            <TextField label={t('farrierMaterials.initialStock')} type="number" value={material.stock_quantity} onChange={(event) => updateField('stock_quantity', event.target.value)} inputProps={{ min: 0, step: '1' }} fullWidth />
            <TextField label={t('farrierMaterials.price')} type="number" value={material.price} onChange={(event) => updateField('price', event.target.value)} inputProps={{ min: 0, step: '0.01' }} fullWidth />
            <Stack direction="row" spacing={1.5} justifyContent="flex-end">
              <Button onClick={() => navigate('/farrier-materials')} sx={{ color: COLORS.muted, fontWeight: 900 }}>{t('cancel')}</Button>
              <Button type="submit" disabled={saving} variant="contained" startIcon={<SaveIcon />} sx={{ bgcolor: COLORS.gold, '&:hover': { bgcolor: COLORS.goldHover }, fontWeight: 900 }}>{t('save')}</Button>
            </Stack>
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
};

export default FarrierMaterialAdd;
